// src/hooks/useLangPath.ts
import { useParams } from "react-router-dom";

export const useLangPath = () => {
  const { lang } = useParams<{ lang: string }>();
  return (path: string) => `/${lang}${path}`;
};
